module.exports = __webpack_public_path__ + "img/desktop.svg.8fd999f9.png";